module.exports = __webpack_public_path__ + "static/img/qudi (11).d8a6192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (11).jpg
// module id = 3X46
// module chunks = 0